export const FOLDER_STRUCTURES = {
  DIVISION_STUDENT_POSES: "division/student/poses",
  // STUDENT_POSES: "student/poses",
};

export const FOLDER_STRUCTURE_PATTERNS = {
  [FOLDER_STRUCTURES.DIVISION_STUDENT_POSES]: {
    minDepth: 3,
    description: "division_id/student_id/pose-name.jpg",
    example: "A_Division/student_123/pose-1.jpg",
    validation: (pathParts) => pathParts.length >= 3,
  },
  //   [FOLDER_STRUCTURES.STUDENT_POSES]: {
  //     minDepth: 2,
  //     description: "student_id/pose-name.jpg",
  //     example: "student_123/pose-1.jpg",
  //     validation: (pathParts) => pathParts.length >= 2,
  //   },
};
export const ALLOWED_EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
export const UPLOAD_STATUS = {
  PENDING: "pending",
  UPLOADING: "uploading",
  SUCCESS: "success",
  FAILED: "failed",
  CANCELLED: "cancelled",
};
export const IMAGE_UPLOAD_TYPES = {
  SCHOOL_LOGO: "school_logo",
  GROUP_IMAGE: "group_image",
  PACKAGE_IMAGE: "generic_package_image",
  STUDENT_IMAGE_FOLDER: "student_image_folder",
  STUDENT_IMAGE: "student_image",
  STUDENT_ADMIN_POSE_LIST_IMAGE: "student_pose_list_admin_side",
};
export const VALIDATION_MESSAGES = {
  NO_FILES: "No files selected for upload",
  INVALID_STRUCTURE: "Invalid folder structure detected",
  FILE_TOO_LARGE: "File must be smaller than 150MB",
  NOT_IMAGE: "Only image files are allowed",
  FORM_INCOMPLETE: "Please fill in all required fields",
  MIXED_STRUCTURES:
    "Mixed folder structures detected. Please use consistent structure.",
};

export const S3_IMAGE_SIZE = 150;
export const S3_BUCKET_TIMEOUT = 600000; // 10 minutes per file
